import { IGameIdentityScoresState } from "source/app/presentation/MainPanel/GameIdentities/GameIdentityScores";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";

export function GetGameIdentityForGoal(goalId: number) {
    const gameIdentityScoresState = State.ReadClass<IGameIdentityScoresState>(
        ESharedComponent.GameIdentityScores
    );

    if (!gameIdentityScoresState) {
        return undefined;
    }

    const gameIdentityScore =
        gameIdentityScoresState.state.gameIdentityScores.find(
            (igid) => igid.claimgoalid === goalId
        );

    if (!gameIdentityScore) {
        return undefined;
    }

    return gameIdentityScore;
}
